import React from 'react';
import { Provider as DataProvider } from './dataProvider';
import { Provider as ScoutSessionProvider } from './scoutSessionProvider';

export function Providers ({children}: {children: React.ReactNode}) {
    return (
        <ScoutSessionProvider>
        <DataProvider>
            {children}
        </DataProvider>
        </ScoutSessionProvider>
    )
}